export const nFormat = (nStr) => {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

export const getDateFormatted = (timstamp) => {
    const fecha = new Date(timstamp);

    // Obtener año, mes y día
    const year = fecha.getUTCFullYear();
    const month = String(fecha.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() devuelve 0-11
    const day = String(fecha.getUTCDate()).padStart(2, '0');
    
    // Formatear en YYYY-MM-DD
    const fechaFormateada = `${year}-${month}-${day}`;
    
    return fechaFormateada;
}

export const diffDays = (date1, date2) => {
  // Convertimos YYYY-MM-DD a fecha local
  const d1 = new Date(date1 + "T00:00:00");
  const d2 = new Date(date2 + "T00:00:00");

  const diffTime = d2 - d1; // diferencia en milisegundos
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return diffDays;
}